import API from "@/models/API";

export default class User {
    constructor(item = {}) {
        this.user_id = item.user_id || null;
        this.mobile = item.mobile || "";
        this.country_id = item.country_id || null;
        this.password = item.password || "";
        this.permissions = item.permissions || {};
        this.user = item.user || "";
        this.role_id = item.role_id || null;
        this.user_account_id = item.user_account_id || null;

    }

    static checkPermissionsStatus(permissions) {
        for (let key in permissions) {
            if (typeof permissions[key] !== "object") {
                if (permissions[key]) {
                    return true;
                }
            } else {
                let subPermissions = permissions[key];

                for (let key in subPermissions) {
                    if (typeof subPermissions[key] !== "object") {
                        if (subPermissions[key]) {
                            return true;
                        }
                    } else {
                        for (let subKey in subPermissions[key]) {
                            if (subPermissions[key][subKey]) {
                                return true;
                            }
                        }
                    }
                }
            }
        }

        return false;
    }

    static getModeratorPermissions = () =>
        API.get(
            `/users/default-permissions`
        );

    static get = () =>
        API.get(`/stores/${localStorage.getItem("storeId")}/users/all`);

    static getItem = id =>
        API.get(
            `/stores/${localStorage.getItem("storeId")}/users/${id}/profile`
        );

    static create = item =>
        API.post(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/users/create-store-moderator`,
            item
        );

    static update = (id, item) =>
        API.put(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/users/${id}/permissions`,
            item
        );

        static upgrade = id =>
        API.put(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/users/upgrade/${id}`
        );
        

        static downgrade = id =>
        API.put(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/users/downgrade/${id}`
        );
        

        static delete = id =>
        API.delete(
            `/stores/${localStorage.getItem(
                "storeId"
            )}/users/${id}`
        );

        static getRoles = () =>
            API.get(`/common/roles`);
}
